import BtxSwitch from '../../../Forms/BtxSwitch';
import { Col, Row } from 'reactstrap';
import { useState } from 'react';

function PartnerSubOfferingList({
    subOfferings = [],
    disabled = true,
    callBack = () => {},
}) {
    return (
        <>
            {subOfferings.sort((a, b) => a.name.localeCompare(b.name)).map((so) => {
                return (
                    <Row
                        className="align-items-center justify-content-center"
                        key={so.id}>
                        <Col lg="2" xs="6">
                            <CustomSwitch
                                value={so.isEnabled}
                                disabled={disabled}
                                id={so.id}
                                callBack={callBack}
                            />
                        </Col>
                        <Col lg="6" xs="6">
                            <span>{so.name}</span>
                        </Col>
                    </Row>
                );
            })}
        </>
    );
}

const CustomSwitch = ({value, disabled, callBack = ()=>{}, id }) => {
    const [switchState, setswitchState] = useState(value);
    const update = () => {
        callBack({id: id, value: !switchState});
        setswitchState(!switchState);
    };
    return (
        <BtxSwitch
            value={switchState}
            disabled={disabled}
            onChange={update}
        />
    );
};

export default PartnerSubOfferingList;
